import { CategoryType } from "../../components/CategorySelect"
import { Pagination } from "./common";
import { API_URL } from "../config";

export interface Channel {
  title: string;
  href: string;
  img: string;
}

export interface SearchResult {
  pagination: Pagination;
  channels: Channel[];
}

export async function search(
  query: string,
  category: CategoryType,
  page: number = 0
): Promise<SearchResult> {
  return await (
    await fetch(
      API_URL +
        "/search?" +
        new URLSearchParams({ k: query, p: page.toString(), category }).toString()
    )
  ).json();
}
